/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Current_PeriodInputs */

const en_settings_billing_current_period = /** @type {(inputs: Settings_Billing_Current_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current period`)
};

/**
* | output |
* | --- |
* | "Current period" |
*
* @param {Settings_Billing_Current_PeriodInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_current_period = /** @type {((inputs?: Settings_Billing_Current_PeriodInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Current_PeriodInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_current_period(inputs)
});
export { settings_billing_current_period as "settings.billing.current_period" }